import Card from "components/card";
import { MdAutoAwesome } from "react-icons/md";
import { BiNetworkChart } from "react-icons/bi";

const MentorMatchingStats = () => {
  // Algorithm performance metrics
  const totalRecommendations = 48923; // Total recommendations made
  const uniqueMentors = 1847; // Unique mentors in the system
  const avgMentorsPerUser = 14; // Average number of mentors recommended to each user

  // Format large numbers
  const formatNumber = (num: number) => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}k`;
    }
    return num.toString();
  };

  return (
    <Card extra="p-6 h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-bold text-navy-700 dark:text-white">
          Latte Algorithm Stats
        </h3>
        <BiNetworkChart className="text-xl text-brand-500" />
      </div>

      {/* Main metric - Total Recommendations */}
      <div className="mb-6 text-center">
        <div className="flex items-center justify-center gap-2 mb-2">
          <MdAutoAwesome className="text-3xl text-yellow-500" />
          <div className="text-4xl font-bold text-navy-700 dark:text-white">
            {formatNumber(totalRecommendations)}
          </div>
        </div>
        <p className="text-sm text-gray-600">Total Recommendations</p>
      </div>

      {/* Secondary metrics */}
      <div className="grid grid-cols-2 gap-4">
        <div className="text-center p-4 bg-gray-50 dark:bg-navy-800 rounded-lg">
          <p className="text-2xl font-bold text-navy-700 dark:text-white mb-1">
            {formatNumber(uniqueMentors)}
          </p>
          <p className="text-xs text-gray-600">Available Mentors</p>
        </div>
        <div className="text-center p-4 bg-gray-50 dark:bg-navy-800 rounded-lg">
          <p className="text-2xl font-bold text-navy-700 dark:text-white mb-1">
            {avgMentorsPerUser}
          </p>
          <p className="text-xs text-gray-600">Avg Mentors/User</p>
        </div>
      </div>
    </Card>
  );
};

export default MentorMatchingStats;